import '../../assets/styles/frameworks.css' // eslint-disable-line import/no-unassigned-import
import '../../assets/styles/transition.less' // eslint-disable-line import/no-unassigned-import
import '../../assets/styles/main.less' // eslint-disable-line import/no-unassigned-import

// eslint-disable-next-line import/no-unassigned-import
import '@ant-design/v5-patch-for-react-19'

import { useRedirect } from '@mbfab/frontend-common'
import { extendProperties } from '@mbfab/shared'
import dayjs from 'dayjs'
import LogRocket from 'logrocket'
import type { AppProps } from 'next/app'
import { useRouter } from 'next/router'
import { isIE } from 'react-device-detect'

import { AdminLayout } from '../layouts/AdminLayout'
import { DefaultProvider } from '../layouts/base/DefaultProvider'
import { isMaintainancePeriod, MaintainanceLayout } from '../layouts/MaintainanceLayout'
import { MemberLayout } from '../layouts/MemberLayout'
import { NoMemberLayout } from '../layouts/NoMemberLayout'
import { UserSelectLayout } from '../layouts/TenantSelectLayout'
import { envVariables } from '../lib/env'

extendProperties()

dayjs.locale('ja')

const NO_MEMBER_LAYOUT_PATHS = ['/sign_up', '/sign_in', '/sign_out', '/ie', '/error', '/clear_cache']
const USER_SELECT_LAYOUT_PATHS = ['/']

const Page = (props: AppProps) => {
  const { router } = props
  const routerByHooks = useRouter()

  // SPA only
  if (typeof window === 'undefined') {
    return <></>
  }

  const redirect = useRedirect()

  if (envVariables.NODE_ENV !== 'development') {
    LogRocket.init('czedne/mbfab-manager') // TODO: どこでやるべきか？
  }

  if (isMaintainancePeriod()) {
    return <MaintainanceLayout />
  }

  // IEは非対応
  if (isIE && router.pathname !== '/ie') {
    redirect('/ie')
  }

  // タブを立ち上げっぱなしで、古いバージョンのjsが使われ続けるのを防ぐため、6時間おきに画面をリロードする
  setTimeout(
    () => {
      location.reload()
    },
    6 * 60 * 60 * 1000,
  )

  // なぜか本番で正しくLayoutが選択されていないため、一旦ログを表示 TODO: あとで除去する
  // eslint-disable-next-line no-console
  console.log(
    `_app.tsx`,
    router.pathname,
    router.asPath,
    routerByHooks.pathname,
    routerByHooks.asPath,
    window.location.pathname,
    window.location.href,
  )

  if (NO_MEMBER_LAYOUT_PATHS.includes(router.asPath)) {
    return (
      <DefaultProvider>
        <NoMemberLayout {...props} />
      </DefaultProvider>
    )
  }

  if (router.asPath.startsWith('/t/')) {
    return (
      <DefaultProvider>
        <MemberLayout {...props} />
      </DefaultProvider>
    )
  }

  if (router.asPath.startsWith('/admin/')) {
    return (
      <DefaultProvider>
        <AdminLayout {...props} />
      </DefaultProvider>
    )
  }

  return (
    <DefaultProvider>
      <UserSelectLayout {...props} />
    </DefaultProvider>
  )
}
export default Page
